module.exports = __webpack_public_path__ + "static/media/raiff-screen07.211e9900.jpg";